<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<ThePageLoading v-if="isPageLoading"></ThePageLoading>
					
					<div class="page-container card col-md-8" v-if="!isPageLoading">
						<ThePageHeader @delete-event="deleteAccount" :renderDelete="(identifier != null ? true : false)" :isDeleting="isDeleting"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							<div class="col-md-12 p-4">
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Code:</label>
									</div>
												
									<div class="col-md-6">
										<InputText class="p-inputtext" type="text" maxlength="10" placeholder="Code" v-model="account.code" />
									</div>
								</div>
								
								<div class="row mb-3">
									<div class="col-md-3">
										<label class="col-form-label-title">Type:</label>
									</div>
												
									<div class="col-md-6">
										<InputText class="p-inputtext" type="text" maxlength="100" placeholder="Type" v-model="account.type" />
									</div>
								</div>
								
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Description:</label>
									</div>
												
									<div class="col-md-6">
										<Textarea class="p-inputtext" type="text" rows="5" cols="30" maxlength="255" placeholder="Description" v-model="account.description" />
									</div>
								</div>
													
								<div class="row mb-3" v-if="identifier != null">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Status:</label>
									</div>
												
									<div class="col-md-6">
										<Dropdown :options="getActiveStatuses(statuses)" optionLabel="name" optionValue="value" placeholder="-- Please Select --" v-model="account.isClosed" />
									</div>
								</div>
											
								<div class="row mb-3">
									<div class="col-md-3"></div>
												
									<div class="d-flex col-md-6">
										<Button class="p-button-sm" :disabled="v$.account.$invalid || isLoading" @click="identifier == null ? save() : update()" label="Save"/>
										<span class="p-1"></span>
										<Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel"/>
													
										<TheLoading v-if="isLoading"></TheLoading>
									</div>
								</div>
							</div>
						</div>
						
						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router"
	import store from "@/store";
	import accountApi from "@/api/account-api"
	import statusMixin from "@/mixin/status"
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	
	import useVuelidate from "@vuelidate/core"
	import { required } from "@vuelidate/validators"
	
	export default defineComponent({
		mixins: [statusMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			ThePageLoading,
			TheLoading,
			ThePageError,
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				identifier: useRoute().params.id,
				account: {code: '', type: '', description: '', isClosed: false},
				isPageLoading: false,
				isLoading: false,
				isDeleting: false,
			}
		},
		mounted: function() {
			if (this.pageError == '') {
				this.isPageLoading = true;
								
				let r1 = null;
				if (this.identifier != null) {
					r1 = accountApi.accountView(this.identifier)
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						})
				}
				
				Promise.all([r1]).then((values: any) => {
					if (values != null) {
						for (var i = 0; i < values.length; i++) {
							if (values[i] != null) {
								if (values[i].success) {
									if (values[i].data != null) {
										if (i == 0) {
											this.account = values[i].data.account;
										}
									}
								}
							}
						}
					}
					this.isPageLoading = false;
				})
				.catch(error => {
					this.isPageLoading = false;
					this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
				})
			}
		},
		methods: {
			save() {
				this.isLoading = true;
				
				accountApi.accountSave({
						account: this.account
					})
					.then(response => {
						store.getters.getCached.page = null;
						this.isLoading = false;
						this.$router.push("/admin/account");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			update() {
				this.isLoading = true;
				accountApi.accountUpdate({
						account: this.account
					})
					.then(response => {
						this.isLoading = false;
						this.$router.push("/admin/account");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			deleteAccount() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure want to delete this account?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isDeleting = true;
						accountApi.accountDelete({
								account: this.account
							})
							.then((response: any) => {
								store.getters.getCached.page = null;
								this.isDeleting = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.$router.push("/admin/account");
							})
							.catch(error => {
								this.isDeleting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				})
			},
			cancel() {
				this.$router.push("/admin/account");
			},
		},
		setup() {
			return { v$: useVuelidate() }
		},
		validations() {
			return {
				account : {
					code: {
						required
					},
					description: {
						required
					},
					isClosed: {
						required
					},
				}
			}
		}
	});
</script>
